import { render, staticRenderFns } from "./causeDeduction.vue?vue&type=template&id=5bd09177&scoped=true"
import script from "./causeDeduction.vue?vue&type=script&lang=js"
export * from "./causeDeduction.vue?vue&type=script&lang=js"
import style0 from "./causeDeduction.vue?vue&type=style&index=0&id=5bd09177&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd09177",
  null
  
)

export default component.exports